const info = {
    CN: {
        banner: {
            title: "安农保AI智能农险服务",
            text: "安农保是自主研发的农险智能科技平台，依托“卫星遥感+无人机航拍+移动终端采集”全链条技术支撑体系，构建“天、空、地”三位一体监测网络。平台深度聚焦农业保险承保与理赔环节，为保险公司提供从地块建库、作物识别、灾害评估到精准理赔的一站式科技服务。",
        },
        serviceIntro: {
            title: "安农保AI智能农险服务",
            text: "安农保是自主研发的农险智能科技平台，依托“卫星遥感+无人机航拍+移动终端采集”全链条技术支撑体系，构建“天、空、地”三位一体监测网络。平台深度聚焦农业保险承保与理赔环节，为保险公司提供从地块建库、作物识别、灾害评估到精准理赔的一站式科技服务。",
        },
        lovBigData: {
            title: "核心产品与技术能力",
            list: [
                {
                    title: "多源卫星影像自动拼接、作物识别、长势分析",
                    text: "宏观评估承保区域作物分布与长势，支持承保与查勘决策",
                },
                {
                    title: "地块唯一编码、权利人信息采集匹配、权属关联",
                    text: "夯实承保精准底数，支持“按图承保”",
                },
                {
                    title: "地块智能勾画、作物种类识别、灾害类型判定",
                    text: "提升数据采集效率与准确率，减少人工误差",
                },
                {
                    title: "快速直飞、现场影像采集、灾害定损",
                    text: "理赔季快速响应，精准核定损失面积与程度",
                },
                {
                    title: "线下人员全场景作业工具，覆盖查勘、核验、采集",
                    text: "从“线下跑腿”到“线上办理”，大幅提升一线效率",
                },
                {
                    title: "地块信息与承保数据自动关联、逻辑校验、异常预警",
                    text: "确保数据质量合规，满足监管报送与审计要求",
                },
            ],
        },
    },
    EN: {
        banner: {
            title: "About Our Services",
            text: "AnNongBao is a self-developed intelligent agri-insurance technology platform. Powered by a full-chain technology support system integrating satellite remote sensing, UAV aerial photography, and mobile terminal collection, it builds a “Space-Air-Ground” trinity monitoring network. The platform focuses deeply on the underwriting and claims processes of agricultural insurance, providing insurers with one-stop technology services ranging from plot database construction, crop identification, and disaster assessment to precision claims settlement.",
        },
        serviceIntro: {
            title: "About Our Services",
            text: "AnNongBao is a self-developed intelligent agri-insurance technology platform. Powered by a full-chain technology support system integrating satellite remote sensing, UAV aerial photography, and mobile terminal collection, it builds a “Space-Air-Ground” trinity monitoring network. The platform focuses deeply on the underwriting and claims processes of agricultural insurance, providing insurers with one-stop technology services ranging from plot database construction, crop identification, and disaster assessment to precision claims settlement.",
        },
        lovBigData: {
            title: "Core Products & Technical Capabilities",
            list: [
                {
                    title: "Multi-source satellite image automatic stitching, crop identification, growth trend analysis",
                    text: "Macro-assessment of crop distribution and growth in insured areas, supporting underwriting and survey decisions",
                },
                {
                    title: "Unique plot coding, rights holder information collection and matching, ownership association",
                    text: "Solidifying accurate underwriting baseline data, supporting “map-based underwriting”",
                },
                {
                    title: "Intelligent plot delineation, crop type identification, disaster type determination",
                    text: "Improving data collection efficiency and accuracy, reducing manual errors",
                },
                {
                    title: "Rapid direct flights, on-site image capture, disaster loss assessment",
                    text: "Quick response during the claims season, accurately verifying loss area and severity",
                },
                {
                    title: "Full-scenario mobile operation tools for field staff, covering survey, verification, and data collection",
                    text: "From “on-foot fieldwork” to “online processing,” greatly enhancing frontline efficiency",
                },
                {
                    title: "Automatic association of plot information with underwriting data, logical validation, anomaly alerts",
                    text: "Ensuring data quality compliance, meeting regulatory reporting and audit requirements",
                },
            ],
        },
    },
};

export default info;
